module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/age.json
// module id = 1056
// module chunks = 180156644297309